import { SideMenuProvider } from '@/pages/CompanyReport/components/Overview/components/SideMenu/context';
import useUser from '@/hooks/useUser';
import loadable from '@loadable/component';
import CompanyReportContents from './CompanyReportContents';
import ReportSplitHandlerProvider from './components/ReportSplitHandlerProvider';
import { VisibleSectionsProvider } from './components/VisibleSectionsContextProvider';
import RecentUpdatesProvider from './components/Overview/components/RecentUpdates/context';
import { CompanyNoteModalProvider } from '@components/Note';
import { useCompanyReportPageUrl } from './hooks/useCompanyReportPageUrl';
import { IntersectionRendererProvider } from '@/pages/CompanyReport/components/IntersectionRenderer';

const DeprecatedStream = loadable(
  () => import('@/components/DeprecatedStream'),
  {
    resolveComponent: (c) => c.DeprecatedStream,
    ssr: false,
  }
);

//This component is required to reset the company report state without
//resetting the sidebar otherwise would cause flickering
const CompanyReport = () => {
  const canonicalUrl = useCompanyReportPageUrl();
  const { data: user } = useUser();
  return (
    <SideMenuProvider>
      <RecentUpdatesProvider>
        <>
          {user.loggedIn && <DeprecatedStream />}
          {/* key is used to refresh component state when visiting new company */}
          <CompanyNoteModalProvider>
            <ReportSplitHandlerProvider key={canonicalUrl}>
              <IntersectionRendererProvider>
                <VisibleSectionsProvider>
                  <CompanyReportContents />
                </VisibleSectionsProvider>
              </IntersectionRendererProvider>
            </ReportSplitHandlerProvider>
          </CompanyNoteModalProvider>
        </>
      </RecentUpdatesProvider>
    </SideMenuProvider>
  );
};
export default CompanyReport;
